/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React TS Base Styles
import colors from "dashboard-template/assets/theme-dark/base/colors";
import borders from "dashboard-template/assets/theme/base/borders";
import { alpha } from "@mui/material/styles";
const { borderRadius } = borders;
const { white, dark, grey } = colors;

// types
type Types = any;

const textField: Types = {
  styleOverrides: {
    root: {
      backgroundColor: alpha(dark.main, 0.7),
      borderRadius: borderRadius.md,
      "& .MuiInputLabel-root.Mui-focused": {
        color: dark.main,
      },

      '& input[type="date"]::-webkit-calendar-picker-indicator': {
        filter: "invert(100%)",
      },
      "& .MuiInputBase-root.Mui-disabled:not(.MuiInputLabel-root.Mui-focused)": {
        backgroundColor:grey[700],
      },

      "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-input": {
        WebkitTextFillColor: white.main,
        color: white.main,
      },
    },
  },
};

export default textField;
